import React, { useEffect } from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import { StripeProvider } from './contexts/StripeContext';

function App() {
  useEffect(() => {

    // Cleanup on unmount
    return () => {
      if (schedulerId) {
        clearInterval(schedulerId);
      }
    };
  }, []);

  return (
    <AuthProvider>
      <StripeProvider>
        <Routes />
      </StripeProvider>        
    </AuthProvider>
  );
}

export default App;